enum PaymentMethodCategory {
  NotSelected = 'NotSelected',
  ExistingPaymentMethod = 'ExistingPaymentMethod',
  Debit = 'Debit',
  RCC = 'RCC',
  MAIL = 'MAIL',
}

export default PaymentMethodCategory;
